import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { createApiClient, type ApiClient } from './client';

const ApiContext = createContext<ApiClient | undefined>(undefined);

export function ApiProvider({
  children,
  client,
}: {
  readonly children: ReactNode;
  readonly client?: ApiClient;
}) {
  const value = useMemo(() => client ?? createApiClient(), [client]);
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const ctx = useContext(ApiContext);
  if (!ctx) {
    throw new Error('useApi() must be used inside <ApiProvider>.');
  }
  return ctx;
}
